import React from 'react';
import { formatCurrency, findResaleCommunityValue, featureHasNoValue, daysListed, formatDetailDate, convertPropType } from '../util/util.js';


function DetailItem({value, format, TagType = 'li'}) {
    return !!value
        ? <TagType>{format(value)}</TagType>
        : null;
}

function DetailBlock({item, showPropType}) {
    const {beds, baths, style, subdivision, year_built, web_id, ad_number, list_type, date_created} = item;
    return (
        <div className="detail-block">
            <ul className="summary-features">
                <DetailItem format={v => `${v}`} value={showPropType && convertPropType(item)} />
                <DetailItem format={v => `${v} bedrooms`} value={beds} />
                <DetailItem format={v => `${v} baths`} value={baths} />
                <DetailItem format={v => `Style: ${v}`} value={style} />
                <DetailItem format={v => `Subdivision ${v}`} value={subdivision} />
                <DetailItem format={v => `Built ${v}`} value={year_built} />
                <DetailItem format={v => `Source Id: ${v}`} value={web_id || ad_number} />
                {item.list_type && item.list_type.toUpperCase() === 'COMMUNITY'
                    ? <DetailItem format={v => `Type: ${v}`} value={list_type} />
                    : <DetailItem format={v => `Listed ${v}`} value={daysListed(date_created)} />
                }
            </ul>
        </div>
    )
}

function Attribution({item}) {
    const agentName = !!item.agent_first_name && !!item.agent_last_name
        ? `${item.agent_first_name} ${item.agent_last_name}`
        : '';
    const businessName = item.broker_business_name || item.property_management_name;
    const phoneNumber = item.broker_day_phone || item.agent_day_phone || item.community_phone || item.property_management_phone;
    const listingString = !!agentName
        ? `Listed by ${agentName} of ${businessName} | ${phoneNumber}`
        : `Listed by ${businessName} | ${phoneNumber}`;

    const attribution = item.list_type && item.list_type.toUpperCase() === 'COMMUNITY'
                            ? "Published in conjunction with our data partners."
                            : `${item.source_attribution} on ${formatDetailDate(item.date_created)}. Updated ${formatDetailDate(item.start_date)}.`
    return (
        <div className="attribution">
            <p>{listingString}</p>
            {typeof window !== 'undefined'
                ? <p dangerouslySetInnerHTML={{ __html: attribution }}/>
                : <p>{attribution}</p>}
            <p>Related listing information is deemed reliable but not guaranteed.</p>
        </div>
    )
}

class FeatureItem extends React.Component {
    render() {
        const {feature} = this.props;
        const label = this.props.label + ':';
        const featureList = (Array.isArray(feature))
                                ? (feature.length > 0)
                                    ? feature.join(", ")
                                    : null
                                : (<span className="value">
                                    {!!feature && (typeof feature === 'string' && feature.toUpperCase() === 'ON') ? 'Yes' : feature}
                                  </span>)
        return ( (!!feature && !!featureList)
                    ? ( <li className="feature">
                            <label>{label}</label> {featureList}
                        </li>)
                    : null
        )
    }
}

function PhoneNumber({label, number}) {
    if (!!number) {
        return (
            <div className="contact-phone">
                {label === 'Fax'
                    ? <>{label}: {number}</>
                    : <>{label}: <a href={"tel://" + number}>{number}</a></>
                }
            </div>
        )
    } else {
        return null;
    }
}

class FloorPlanRow extends React.Component {
    render() {
        const {model, floorplanClick, do_not_display_rent} = this.props;
        return (
            <div className={`row_full ${!!model.floor_plan_url ? "has-plan" : ""}`}
                onClick={() => !!model.floor_plan_url && floorplanClick(model.floor_plan_url)}>
                <div className="row_data">
                    <div className="col_1" >
                        {!!model.floor_plan_url && "View"}
                    </div>
                    <div className="col_2">{model.model_name}</div>
                    <div className="col_3">{!!model.availability ? <img alt="" src="//static.advance.net/static/classifieds/realestate/details/img/icon_greencheck.png" /> : ''}</div>
                    <div className="col_4">{findResaleCommunityValue('COMMUNITY', '', model.beds_min, model.beds_max, '')}</div>
                    <div className="col_5">{findResaleCommunityValue('COMMUNITY', '', model.baths_min, model.baths_max, '')}</div>
                    <div className="col_6">
                        {do_not_display_rent ? "Call for Pricing" : findResaleCommunityValue('COMMUNITY', '', model.rent_min, model.rent_max, '', formatCurrency)}
                    </div>
                    <div className="col_7">
                        {model.sq_footage || findResaleCommunityValue('COMMUNITY', '', model.sqfeet_min, model.sqfeet_max, '')}
                    </div>
                    <div className="col_8">{formatCurrency(model.deposit)}</div>
                </div>
            </div>
        )
    }
}

class FloorPlans extends React.Component {
    render() {
        const {models, do_not_display_rent} = this.props;
        return (
            <div className="details-section floorplans">
                <h2>Floor Plans</h2>
                <div className="floorplan-table">
                    <div className="row_header">
                        <div className="col_1">Floorplan</div>
                        <div className="col_2">Style</div>
                        <div className="col_3">Available now</div>
                        <div className="col_4">Beds</div>
                        <div className="col_5">Baths</div>
                        <div className="col_6">Rent range</div>
                        <div className="col_7">Sq. ft.</div>
                        <div className="col_8">Deposit</div>
                    </div>
                    {models.map((model, index) => {
                        return (<FloorPlanRow
                                  key={index}
                                  model={model}
                                  do_not_display_rent={do_not_display_rent}
                                  floorplanClick={this.props.floorplanClick}
                                 />
                    )})}
                </div>
            </div>
        )
    }
}

class DescriptionBlock extends React.Component {
    render() {
        const {item} = this.props;
        const INTERIOR_FEATURES = [
            {label: "Basement", feature: item.basement},
            {label: "Half Baths", feature: item.halfbaths},
            {label: "Full Baths", feature: item.fullbaths},
            {label: "Bedroom 1 Dimensions", feature: item.bedroom1_dimensions},
            {label: "Bedroom 2 Dimensions", feature: item.bedroom2_dimensions},
            {label: "Bedroom 3 Dimensions", feature: item.bedroom3_dimensions},
            {label: "Bedroom 4 Dimensions", feature: item.bedroom4_dimensions},
            {label: "Bedroom 5 Dimensions", feature: item.bedroom5_dimensions},
            {label: "Bedroom 6 Dimensions", feature: item.bedroom6_dimensions},
            {label: "Breakfast Dimensions", feature: item.breakfast_dimensions},
            {label: "Den Dimensions", feature: item.den_dimensions},
            {label: "Dining Dimensions", feature: item.dining_dimensions},
            {label: "Family Dimensions", feature: item.family_dimensions},
            {label: "Fireplace", feature: item.fireplace},
            {label: "Kitchen Dimensions", feature: item.kitchen_dimensions},
            {label: "Living Dimensions", feature: item.living_dimensions},
            {label: "Master Dimensions", feature: item.master_dimensions},
            {label: "Great Room Level", feature: item.great_level},
            {label: "Laundry", feature: item.laundry},
            {label: "Laundry Dimensions", feature: item.laundry_dimensions},
            {label: "Laundry Room Level", feature: item.laundry_level},
            {label: "Available Rooms", feature: item.rooms}
        ]
        const EXTERIOR_FEATURES = [
            {label: "Acres", feature: item.acres},
            {label: "Construction", feature: item.construction},
            {label: "Deck/Porch", feature: item.deck},
            {label: "Waterfront", feature: item.waterfront},
            {label: "Features", feature: item.exterior},
            {label: "Lot Size", feature: item.lot_size},
            {label: "Lot Dimensions", feature: item.lot_dimensions},
            {label: "Lot Description", feature: item.lot_description},
            {label: "Roof", feature: item.roof}
        ]
        const AMENITY_FEATURES = [
            {label: "Features", feature: item.amenities},
            {label: "Utilities", feature: item.utilities},
            {label: "Heating/Cooling", feature: item.heating_cooling},
            {label: "Utilities Included", feature: item.utilities_included},
            {label: "Affordable Housing", feature: item.affordable_housing},
            {label: "Furnished", feature: item.furnished}
        ]
        const FINANCIAL_FEATURES = [
            {label: "Taxes", feature: formatCurrency(item.taxes)},
            {label: "HOA Fee", feature: item.home_fee}
        ]
        const hideInteriorFeatures = INTERIOR_FEATURES.every( feature => featureHasNoValue(feature.feature));
        const hideExteriorFeatures = EXTERIOR_FEATURES.every( feature => featureHasNoValue(feature.feature));
        const hideAmenityFeatures = AMENITY_FEATURES.every( feature => featureHasNoValue(feature.feature));
        const hideFinancialFeatures = FINANCIAL_FEATURES.every( feature => featureHasNoValue(feature.feature));
        const hideCommunityAmenities = item.community_amenity && item.community_amenity.every( feature => featureHasNoValue(feature));

        return (
            <>
                {!!item.list_type && item.list_type.toUpperCase() === 'COMMUNITY'
                    ?   <div className="window">
                            {!hideCommunityAmenities &&
                                <div className="details-section">
                                    <h2>Community Features</h2>
                                    <ul id="home_interior" className="green_list">
                                        {item.community_amenity.map((amenity, index) => {
                                            return (
                                                <li key={index}>{amenity}</li>
                                        )})}
                                    </ul>
                                </div>
			                }
			            </div>
                    :   <>
                            {!hideInteriorFeatures &&
                                <div className="details-section">
                                    <h2>Interior</h2>
                                    <ul id="home_interior" className="green_list">
                                        {INTERIOR_FEATURES.map((feature, index) => {
                                            return (
                                                <FeatureItem key={index} label={feature.label} feature={feature.feature} />
                                            )
                                        })}
                                    </ul>
                                </div>
                            }
                            {!hideExteriorFeatures &&
                                <div className="details-section">
                                    <h2>Exterior</h2>
                                    <ul id="home_exterior" className="green_list">
                                        {EXTERIOR_FEATURES.map((feature, index) => {
                                            return (
                                                <FeatureItem key={index} label={feature.label} feature={feature.feature} />
                                            )
                                        })}
                                    </ul>
                                </div>
                            }
                            {!hideAmenityFeatures &&
                                <div className="details-section">
                                    <h2>Amenities</h2>
                                    <ul id="home_amenities" className="green_list">
                                        {AMENITY_FEATURES.map((feature, index) => {
                                            return (
                                                <FeatureItem key={index} label={feature.label} feature={feature.feature} />
                                            )
                                        })}
                                    </ul>
                                </div>
                            }
                            {!hideFinancialFeatures &&
                                <div className="details-section">
                                    <h2>Financial</h2>
                                    <ul id="home_financial" className="green_list">
                                        {FINANCIAL_FEATURES.map((feature, index) => {
                                            return (
                                                <FeatureItem key={index} label={feature.label} feature={feature.feature} />
                                            )
                                        })}
                                    </ul>
                                </div>
                            }
                        </>
                }
            </>
        )
    }
}


export {DetailBlock, Attribution, FeatureItem, PhoneNumber, FloorPlans, DescriptionBlock };
